import React, { useEffect, useState } from 'react';
import new_joiners from "../../Assets/Images/new_joiners.jpg"

export default function Newjoiners(){
        return (
            <div className="org-chart">
                <img src={new_joiners} alt="Secondary Manager" />
            </div>
    );
}